import styled from "styled-components";
const THUMB_HEIGHT = "1.325em";
const TRACK_HEIGHT = "0.425em";
const CLIP_EDGES = "0.2em";
const TEMP_BACKGROUND = "#fff0";
const BORDER_RADIUS = "2px";
export default {
    ProgressScale: styled.input.attrs({
        type: "range"
    }) `
    -webkit-appearance: none;
    width: 100%;
    color: ${({ theme }) => theme["brand-primary-600"]};
    position: relative;
    background: ${TEMP_BACKGROUND};
    overflow: hidden;
    transition: all ease 100ms;
    height: var(--thumb-height);

    --thumb-height: ${THUMB_HEIGHT};
    --track-height: ${TRACK_HEIGHT};
    --track-color: ${({ theme }) => theme["gray-500"]};
    --clip-edges: ${CLIP_EDGES};

    //Chrome specific styles

    &::-webkit-slider-runnable-track {
      -webkit-appearance: none;
      height: var(--thumb-height);
      background: linear-gradient(var(--track-color) 0 0) scroll no-repeat center / 100%
        calc(var(--track-height) + 1px); //align the track (after and before progress scale)
      border-radius: ${BORDER_RADIUS};
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: var(--thumb-height);
      position: relative;
      border: ${BORDER_RADIUS} solid ${({ theme }) => theme["brand-primary-300"]};
      color: ${({ theme }) => theme["brand-primary-500"]};
      cursor: grabbing;

      --thumb-radius: 50%;

      //fill evenly progress scale
      --clip-top: calc((var(--thumb-height) - var(--track-height)) * 0.5 - 0.5px);
      --clip-bottom: calc(var(--thumb-height) - var(--clip-top));
      --clip-further: 100%;
      --box-fill: calc(-100vmax - var(--thumb-width, var(--thumb-height))) 0 0 100vmax currentColor;

      width: var(--thumb-width, var(--thumb-height));
      background-color: currentColor;
      box-shadow: var(--box-fill);
      border-radius: var(--thumb-width, var(--thumb-height));

      //The clip-path property allows you to specify a clipping region for an element, which means that any part of the element outside of this region will be hidden.
      clip-path: polygon(
        100% -1px,
        var(--clip-edges) -1px,
        0 var(--clip-top),
        -100vmax var(--clip-top),
        -100vmax var(--clip-bottom),
        0 var(--clip-bottom),
        var(--clip-edges) 100%,
        var(--clip-further) var(--clip-further)
      );
    }

    //Firefox specific styles

    &::-moz-range-thumb {
      background: currentColor;
      color: ${({ theme }) => theme["brand-primary-500"]};
      border: ${BORDER_RADIUS} solid ${({ theme }) => theme["brand-primary-300"]};
      border-radius: 50%;
      cursor: grab;
    }

    &:active::-moz-range-thumb {
      cursor: grabbing;
    }

    &::-moz-range-track {
      width: 100%;
      background: var(--track-color);
    }

    &::-moz-range-progress {
      appearance: none;
      background: currentColor;
      transition-delay: 30ms;
    }

    &::-moz-range-track,
    &::-moz-range-progress {
      height: calc(var(--track-height) + 1px);
      border-radius: var(--track-height);
    }
  `
};
